import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  holizontalLineContainer: {
    marginTop: "10px",
    marginBottom: "10px",
  },

  lineBorder: {
    borderBottom: "1px solid #ccc",
  },
}));

const GrayHorizontalLine = () => {
  const classes = useStyles();
  return (
    <div className={classes.holizontalLineContainer}>
      <div className={classes.lineBorder}></div>
    </div>
  );
};

export default GrayHorizontalLine;
